import Vue from 'vue'
import VueRouter from 'vue-router'

import index from '@/views/index'
import nodeService from '@/views/nodeService'
import aboutUs from '@/views/aboutUs'
import mainBusiness from '@/views/mainBusiness'
import hardWare from '@/views/hardWare'
import newsCenter from '@/views/newsCenter'
import newsDetail from '@/views/newsDetail'

Vue.use(VueRouter)
// let originPush = VueRouter.prototype.push
// let originReplace = Vue.prototype.originReplace

// VueRouter.prototype.push = function (location,res,rej) {
//     if (res && rej ) {
//         originPush.call(this,location,res,rej)
//     } else {
//         originPush.call(this,location,()=>{},()=>{})
//     }
// }

// VueRouter.prototype.replace = function(location ,res,rej) {
//     if (res && rej) {
//         originReplace.call(this,location,res,rej)
//     } else {
//         originReplace.call(this,location,() => {},() => {})
//     }
// }


let routers = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/nodeService',
      name: 'nodeService',
      component: nodeService
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/mainBusiness',
      name: 'mainBusiness',
      component: mainBusiness
    },
    {
      path: '/hardWare',
      name: 'hardWare',
      component: hardWare
    },
    {
      path: '/newsCenter',
      name: 'newsCenter',
      component: newsCenter
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    }
  ]
});

export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js